import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type CreateAttendEventHeaders =
  operations['AdminGroupEventController_createGroupEvent']['parameters']['header'];

type CreateAttendEventData = components['schemas']['AdminCreateGroupEventDto'];

interface CreateAttendEventProps {
  data: CreateAttendEventData;
  headers?: OmitGroupIdInHeader<CreateAttendEventHeaders>;
}

type CreateAttendEventResponse = unknown;

export async function createAttendEvent({
  data,
  headers,
}: CreateAttendEventProps): Promise<CreateAttendEventResponse | false> {
  const response = await authenticateRequest<CreateAttendEventResponse>({
    method: 'post',
    url: `/api/v1/admin/group-event`,
    data,
    headers,
  });

  console.log('postAttendEvent', { response });
  return response;
}

export type { CreateAttendEventResponse };
